import React, { useContext } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Box, Grid, Stack, IconButton, Typography } from "@mui/material";
import { BiMinusCircle } from "react-icons/bi";
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { SelectYearPicker } from "../Include/SelectDatePicker/SelectYearPicker";

export default function SelectYear({
  open,
  handleClose,
  filterYear,
  setFilterYear,
}) {
  // Change Language
  const { t } = useContext(AuthContext);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">{t("select_year")}</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SelectYearPicker
              value={filterYear}
              onChange={(val) => setFilterYear(val || "")}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
